/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { map } from "lodash";
import { useSelector } from "react-redux";
import { useState } from "react";
import { Icon } from "@mui/material";
import moment from "moment";
import toast from "react-hot-toast";

function FormBusqueda({ onSearch }) {
  const { catalogos, catFiltros } = useSelector((state) => state.solicitud);

  const [cmbparentesco, setcmbparentesco] = useState(null);
  const [cmbllenoformato, setcmbllenoformato] = useState(null);
  const [cmbcandidato, setcmbcandidato] = useState(null);
  const [fechaaplicacion, setfechaaplicacion] = useState("");
  const [fechanacimiento, setfechanacimiento] = useState("");

  const handleSearch = () => {
    // Prepara los datos de búsqueda
    const filtros = {
      fechaAplicacion: fechaaplicacion,
      fechaNacimiento: fechanacimiento,
      idParentescoCandidato: cmbparentesco?.idParentescoCandidato || 0,
      idSolicitudLlenoFormato: cmbllenoformato?.idSolicitud || 0,
      idSolicitudNombreMenor: cmbcandidato?.idSolicitud || 0,
    };

    // Llama a la acción de búsqueda
    onSearch(filtros);
  };

  const handleSearchNoFiltros = () => {
    setcmbparentesco(null);
    setcmbllenoformato(null);
    setcmbcandidato(null);
    setfechaaplicacion("");
    setfechanacimiento("");
    // Prepara los datos de búsqueda
    const filtros = {
      fechaAplicacion: "",
      fechaNacimiento: "",
      idParentescoCandidato: 0,
      idSolicitudLlenoFormato: 0,
      idSolicitudNombreMenor: 0,
    };

    // Llama a la acción de búsqueda
    onSearch(filtros);
  };

  return (
    <>
      <Grid container spacing={6}>
        <Grid item xs={12} md={2} lg={2}>
          <MDBox textAlign="center">
            <TextField
              fullWidth
              variant="outlined"
              label="Fecha de aplicación"
              type="date"
              autoComplete="off"
              InputLabelProps={{ shrink: true }}
              value={fechaaplicacion}
              onChange={(e) => setfechaaplicacion(e.target.value)}
              size="small"
              onKeyDown={(e) => e.preventDefault()}
              onPaste={(e) => e.preventDefault()}
              inputProps={{
                max: moment().format("YYYY-MM-DD"),
              }}
              onClick={(e) => e.target.showPicker && e.target.showPicker()}
              style={{ marginBottom: "1rem", cursor: "pointer" }}
            />
          </MDBox>
        </Grid>
        <Grid item xs={12} md={2} lg={2}>
          <MDBox textAlign="center">
            <TextField
              fullWidth
              variant="outlined"
              label="Fecha de nacimiento"
              type="date"
              autoComplete="off"
              InputLabelProps={{ shrink: true }}
              value={fechanacimiento}
              onChange={(e) => setfechanacimiento(e.target.value)}
              size="small"
              onKeyDown={(e) => e.preventDefault()}
              onPaste={(e) => e.preventDefault()}
              inputProps={{
                max: moment().format("YYYY-MM-DD"),
              }}
              onClick={(e) => e.target.showPicker && e.target.showPicker()}
              style={{ marginBottom: "1rem", cursor: "pointer" }}
            />
          </MDBox>
        </Grid>
        <Grid item xs={12} md={2} lg={2}>
          <MDBox textAlign="center">
            <Autocomplete
              options={catalogos.parentescos}
              getOptionLabel={(option) => option.descripcion}
              id="controlled-demo"
              value={cmbparentesco}
              onChange={(event, newValue) => {
                const selectedValue = newValue;
                setcmbparentesco(newValue);
              }}
              renderInput={(params) => (
                <TextField {...params} label={"Parentesco"} variant="outlined" error={false} />
              )}
              style={{ width: "100%", marginBottom: "1rem" }}
              size="small"
            />
          </MDBox>
        </Grid>
        <Grid item xs={12} md={2} lg={2}>
          <MDBox textAlign="center">
            <Autocomplete
              options={catFiltros.comboLlenados}
              getOptionLabel={(option) => option.llenado}
              id="controlled-demo"
              value={cmbllenoformato}
              onChange={(event, newValue) => {
                setcmbllenoformato(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={"Lleno el formato"}
                  variant="outlined"
                  error={false}
                />
              )}
              style={{ width: "100%", marginBottom: "1rem" }}
              size="small"
            />
          </MDBox>
        </Grid>
        <Grid item xs={12} md={3} lg={3}>
          <MDBox textAlign="center">
            <Autocomplete
              options={catFiltros.comboPrecandidatos}
              getOptionLabel={(option) => option.candidato}
              id="controlled-demo"
              value={cmbcandidato}
              onChange={(event, newValue) => {
                setcmbcandidato(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={"Nombre del menor"}
                  variant="outlined"
                  error={false}
                />
              )}
              style={{ width: "100%", marginBottom: "1rem" }}
              size="small"
            />
          </MDBox>
        </Grid>
        <Grid item xs={12} md={1} lg={1}>
          <MDBox textAlign="center">
            <Button variant="contained" onClick={handleSearch} size="small" color="primary">
              <Icon size="medium">search</Icon>
            </Button>
            <Button
              variant="contained"
              onClick={handleSearchNoFiltros}
              size="small"
              color="secondary"
            >
              <Icon size="medium">replay</Icon>
            </Button>
          </MDBox>
        </Grid>
      </Grid>
    </>
  );
}

export default FormBusqueda;
